import { z } from "zod";
import { asCategoryId, asTemplateId, asTodoId, ok } from "@pack-it-up/shared";
import { AssignmentSchema, CompletionSchema, RelativeOffsetSchema, assignmentToDomain, assignmentToDto, calendarDate, completionToDomain, completionToDto, firestoreTimestamp, ProvenanceSchema, parseDto, provenanceToDomain, provenanceToDto, toTimestamp, } from "./common.js";
export const TodoDtoSchema = z.object({
    id: z.string(),
    categoryId: z.string(),
    name: z.string(),
    description: z.string().optional(),
    notes: z.string().optional(),
    tags: z.array(z.string()).optional(), // T29 — user-defined tags; absent, never []
    assignment: AssignmentSchema,
    completions: CompletionSchema,
    dueDate: calendarDate().optional(),
    relativeDueOffset: RelativeOffsetSchema.optional(),
    dueDateManuallyOverridden: z.boolean(),
    remindersSentTo: z.record(z.string(), firestoreTimestamp()),
    reminderComplete: z.boolean(),
    order: z.string(),
    provenance: ProvenanceSchema.optional(),
    templateIds: z.array(z.string()).optional(),
});
export const toDomainTodo = (raw) => {
    const p = parseDto(TodoDtoSchema, raw, "TodoItem");
    if (!p.ok)
        return p;
    const d = p.value;
    const remindersSentTo = {};
    for (const [uid, at] of Object.entries(d.remindersSentTo)) {
        remindersSentTo[uid] = at;
    }
    const todo = {
        id: asTodoId(d.id),
        categoryId: asCategoryId(d.categoryId),
        name: d.name,
        ...(d.description !== undefined ? { description: d.description } : {}),
        ...(d.notes !== undefined ? { notes: d.notes } : {}),
        ...(d.tags !== undefined ? { tags: d.tags } : {}),
        assignment: assignmentToDomain(d.assignment),
        completions: completionToDomain(d.completions),
        ...(d.dueDate !== undefined ? { dueDate: d.dueDate } : {}),
        ...(d.relativeDueOffset !== undefined ? { relativeDueOffset: d.relativeDueOffset } : {}),
        dueDateManuallyOverridden: d.dueDateManuallyOverridden,
        remindersSentTo,
        reminderComplete: d.reminderComplete,
        order: d.order,
        ...(d.provenance !== undefined ? { provenance: provenanceToDomain(d.provenance) } : {}),
        ...(d.templateIds !== undefined ? { templateIds: d.templateIds.map((t) => asTemplateId(t)) } : {}),
    };
    return ok(todo);
};
export const toTodoDto = (t) => {
    const remindersSentTo = {};
    for (const [uid, at] of Object.entries(t.remindersSentTo))
        remindersSentTo[uid] = toTimestamp(at);
    return {
        id: t.id,
        categoryId: t.categoryId,
        name: t.name,
        ...(t.description !== undefined ? { description: t.description } : {}),
        ...(t.notes !== undefined ? { notes: t.notes } : {}),
        ...(t.tags !== undefined ? { tags: t.tags } : {}),
        assignment: assignmentToDto(t.assignment),
        completions: completionToDto(t.completions),
        ...(t.dueDate !== undefined ? { dueDate: t.dueDate } : {}),
        ...(t.relativeDueOffset !== undefined ? { relativeDueOffset: t.relativeDueOffset } : {}),
        dueDateManuallyOverridden: t.dueDateManuallyOverridden,
        remindersSentTo,
        reminderComplete: t.reminderComplete,
        order: t.order,
        ...(t.provenance !== undefined ? { provenance: provenanceToDto(t.provenance) } : {}),
        ...(t.templateIds !== undefined ? { templateIds: t.templateIds } : {}),
    };
};
//# sourceMappingURL=todo.mapper.js.map